import './main.less';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../../../modules/shared/render-views-state';
import { actions, selectors } from './';
import Header from './components/header/main';
import Intro from './components/intro/main';
import Footer from './components/footer/main';
import MainStore from './components/store/main';

const Main = renderViewsState(
	props => {
		const { intl, data, categories, availableLanguages, lang, query, toggleOrderItem,
			changeLang, isHamburgerActive, navbarMenu, popupInfo, toggleOnlyAvailable,
			handleHamburgerClick, logout, handleOrder, paginateGoods, saveUpForGood,
			hidePopup, initPopup, searchGoods, toggleCategoryItem, goodCardNumber, isOrderButtonDisabled
		} = props;
		return (
			<div className='market__main'>
				<Header
					intl={intl}
					user={data.user}
					availableLanguages={availableLanguages}
					lang={lang}
					changeLang={changeLang}
					isHamburgerActive={isHamburgerActive}
					navbarMenu={navbarMenu}
					handleHamburgerClick={handleHamburgerClick}
					logout={logout}
				/>
				<Intro user={data.user} intl={intl} />
				<MainStore
					searchGoods={searchGoods}
					categories={categories}
					toggleCategoryItem={toggleCategoryItem}
					toggleOnlyAvailable={toggleOnlyAvailable}
					toggleOrderItem={toggleOrderItem}
					saveUpForGood={saveUpForGood}
					paginateGoods={paginateGoods}
					goodCardNumber={goodCardNumber}
					isOrderButtonDisabled={isOrderButtonDisabled}
					intl={intl}
					user={data.user}
					goods={data}
					query={query}
					currentLang={lang}
					handleOrder={handleOrder}
					popupInfo={popupInfo}
					hidePopup={hidePopup}
					initPopup={initPopup}
				/>
				<Footer intl={intl} />
			</div>
		);
	}
);

Main.propTypes = {
	intl: PropTypes.func,
	paginateGoods: PropTypes.func,
	searchGoods: PropTypes.func,
	data: PropTypes.object,
	availableLanguages: PropTypes.array,
	lang: PropTypes.string,
	popupInfo: PropTypes.object,
	changeLang: PropTypes.func,
	hidePopup: PropTypes.func,
	saveUpForGood: PropTypes.func,
	isHamburgerActive: PropTypes.bool,
	goodCardNumber: PropTypes.number,
	navbarMenu: PropTypes.array,
	handleHamburgerClick: PropTypes.func,
	logout: PropTypes.func,
	handleOrder: PropTypes.func
};

export default connect(
	state => ({
		data: selectors.getData(state),
		categories: selectors.getCategories(state),
		query: selectors.getQuery(state),
		intl: selectors.getIntl(state),
		availableLanguages: selectors.getAvailableLangs(),
		lang: selectors.getCurrentLang(state),
		isOrderButtonDisabled: selectors.getIsOrderButtonDisabled(state),
		isHamburgerActive: selectors.getIsHamburgerActive(state),
		popupInfo: selectors.getPopupInfo(state),
		navbarMenu: selectors.getNavbarMenu()
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/main.js